export default {
  title: 'Program opinii Google',
  sections: {
    google_review_settings: 'Ustawienia programu opinii Google',
  },
  form: {
    reward: {
      label: 'Nagroda (punkty)',
      point_value: '100 punktów = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Czas trwania',
      options: {
        false: 'Bezterminowo',
        true: 'Z określoną datą końcową',
      },
    },
    end_date: {
      label: 'Data zakończenia',
    },
  },
  tags: {
    inactive: 'Nieaktywny',
    active: 'Aktywny',
    expired: 'Wygasły',
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    changes_got_saved: 'Zmiany zostały zapisane',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
  },
};
